import { render, staticRenderFns } from "./ShopExpire.vue?vue&type=template&id=7028f886&scoped=true&lang=pug&"
import script from "./ShopExpire.vue?vue&type=script&lang=js&"
export * from "./ShopExpire.vue?vue&type=script&lang=js&"
import style0 from "./ShopExpire.vue?vue&type=style&index=0&id=7028f886&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7028f886",
  null
  
)

export default component.exports